<template>
  <div class="misc-wrapper">

    <b-link class="brand-logo">
      <h2 class="brand-text text-primary ml-1">
        <code
          class="text-primary bg-transparent"
          translate="no"
        >goaligner<small>®</small></code>
      </h2>
    </b-link>

    <div class=" p-2 p-sm-3">
      <div class="text-center">
        <h2 class="mb-1">
          Procedimiento agendado con éxito
        </h2>
        <p class="mb-3">
          Tu cita ha sido registrada correctamente.
        </p>
      </div>

      <resume-schedule-card />

      <div v-if="userExists">
        <b-button
          class="float-right"
          :to="{ name: 'schedule-create' }"
        >
          Agendar otro
        </b-button>
      </div>

    </div>

  </div>
</template>

<script>
import {
  BRow, BCol, BLink, BButton, BImg, BForm, BFormInput, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import ResumeScheduleCard from './ResumeScheduleCard.vue'

export default {
  components: {
    BSpinner,
    BFormInput,
    BForm,
    BImg,
    BButton,
    VuexyLogo,
    BLink,
    BRow,
    BCol,

    ResumeScheduleCard,
  },
  data() {
    return {
      userExists: null,
    }
  },
  mounted() {
    this.userExists = !!localStorage.getItem('userSchedule')
  },
}
</script>

<style lang="scss">

@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/pages/page-misc.scss';

</style>
